import { DeviceStatusIndicator } from '@repo/videa-notes';

import { useRecorderState } from '../../../context/VideaNotesRecordingContext';

export const RecordingFlowHeaderStatus = () => {
  const { mediaBlobUrl, recorderStatus } = useRecorderState();

  const isRecording =
    recorderStatus === 'recording' || recorderStatus === 'paused';
  if (mediaBlobUrl || isRecording) {
    return null;
  }

  return (
    <div className="vai-w-full vai-min-w-0 vai-flex vai-items-center">
      <DeviceStatusIndicator />
    </div>
  );
};
